export default __webpack_public_path__ + "static/media/641.f1973340.png";